import { render, staticRenderFns } from "./shop-product-amount-min.vue?vue&type=template&id=4fa229c0&scoped=true&"
import script from "./shop-product-amount-min.vue?vue&type=script&lang=js&"
export * from "./shop-product-amount-min.vue?vue&type=script&lang=js&"
import style0 from "./shop-product-amount-min.vue?vue&type=style&index=0&id=4fa229c0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fa229c0",
  null
  
)

export default component.exports